import './hero.css';

export default function Hero() {
    return (
        <div className='hero'>
            <div className='hero__content'>
                <h1 className='hero__logo'>SVAREX</h1>

                <h5 className='hero__text'>
                    {/* OFFERING PROPERTY REFURBISHMENT, REPAIR, AND CONSTRUCTION */}
                    Property Maintenance
                </h5>

                {/* Connect with us */}
                <button className='hero__button' onClick={() => {
                    const section = document.querySelector('.contact')
                    section.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                    }); // https://stackoverflow.com/a/62173627
                }}>
                    CONTACT US
                </button>
                {/* About us */}
                <button className='hero__button' onClick={() => {
                    const section = document.querySelector('.about')
                    section.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                    }); // https://stackoverflow.com/a/62173627
                }}>
                    READ MORE
                </button>
            </div>
        </div>
    );
}
